<div class="stage">
  <div style="text-align: center">
    <span class="mat-title"> Escolha um plano para efetuar seu cadastro </span>
    <p>Gratuito por 30 dias</p>
  </div>

  <ng-container *ngIf="isFree">
    <div class="empty-content">
      <p class="mat-body-2">
        Sua conta esta selecionado para o perfil gratuito
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="isFree">
    <div class="empty-content">
      <p class="mat-body-2">
        Sua conta esta selecionado para o perfil gratuito
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="special_plan">
    <div class="plan-border-highlight">
      <h2>🎯 Plano Trimestral Plus IA</h2>
      <p>Estamos quase lá! Seu plano Trimestral Plus IA está pronto para ser ativado</p>
      <spam>Conclua seu cadastro para ativá-lo.</spam>
    </div>
  </ng-container>

  <ng-container *ngIf="!isFree && !special_plan"> 
    <app-plan-slide
      #PlanSlide
      [planType]="'BUSINESS'"
      (choosePlan)="choosePlan($event)"
    ></app-plan-slide>
  </ng-container>

  <form [formGroup]="formPlan" (submit)="choosePlan(false)">
    
    <div class="voucher-form-container">
      <div style="text-align: center">
        <span class="mat-title"> Cupom </span>
        <span class="helper" [class.success-background]="success">
          <mat-icon *ngIf="!success">loyalty</mat-icon>
          <mat-icon *ngIf="success" style="color: #f3fff3; padding: 5px;"
            >check_circle</mat-icon
          >
          {{ message }}
        </span>
      </div>
      <form
        [formGroup]="formVoucher"
        (submit)="submitCode()"
        style="margin-top: 20px"
      >
        <div class="row">
          <mat-form-field appearance="outline" id="tourPaymentCupom">
            <mat-label>Código de cupom</mat-label>
            <input
              type="text"
              matInput
              placeholder="Informe o código aqui"
              class="voucher-code"
              formControlName="code"
              maxlength="8"
              [readonly]="formVoucher.get('code').disabled"
            />
          </mat-form-field>
        </div>

        <div class="actions" *ngIf="!success">
          <button
            type="submit"
            mat-raised-button
            color="primary"
            class="custom-primary"
          >
            Enviar Cupom
          </button>
        </div>
      </form>
    </div>
    
    <div class="row">
      <mat-checkbox color="primary" formControlName="acceptTerm" required>
        Aceito os termos de uso da plataforma
        <a
          href="https://colloca.com.br/wp-content/uploads/2024/01/Termos-de-uso-Politica-de-Privacidade-e-LGPD.pdf"
          target="_blank"
          >(ler termo de uso)</a
        >
      </mat-checkbox>
    </div>
    <div class="row">
      <mat-error *ngIf="!formPlan.get('acceptTerm').value">
        É necessário aceitar os termos de uso
      </mat-error>
    </div>
    <div class="row">
      <mat-checkbox color="primary" formControlName="acceptContract" required>
        Aceito o contrato da plataforma
        <a
          href="https://colloca.com.br/wp-content/uploads/2024/01/CONTRATO-PJ-Ajustado-24.01.2024.pdf"
          target="_blank"
          >(ler contrato)</a
        >
      </mat-checkbox>
    </div>
    <div class="row">
      <mat-error *ngIf="!formPlan.get('acceptContract').value">
        É necessário aceitar o contrato
      </mat-error>
    </div>
    <!-- <div class="row">
            <mat-checkbox color="primary" formControlName="acceptSendMessage">
                Autorizo que a Colloca me envie mensagens e informações sobre a ferramenta
            </mat-checkbox>
        </div> -->
    <div class="actions">
      <button
        mat-raised-button
        class="custom-primary"
        type="submit"
        [disabled]="!formPlan.valid || !planoselecionado"
        (click)="doneAll()"
        matStepperNext
      >
        Continuar
      </button>
    </div>
  </form>
</div>

<iframe
  *ngIf="mauticFormSrc"
  [src]="mauticFormSrc"
  hidden
  frameborder="0"
></iframe>
